import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  updateSearch,
  updateSearchResults,
  updateSearchType,
  updateSearchTerm,
  updateSearchIsOpen,
  updateSearchSelected,
} from '../../actions/search.jsx';
import './AppSearchResults.scss';
import AppSearchResult from './AppSearchResult.jsx';
import { GeckoAlert, GeckoIcon } from '../../ui';

class AppSearchResults extends Component {
  close() {
    this.props.updateSearch({
      results: [],
      term: '',
      type: null,
      isOpen: false,
    });
    this.props.updateSelected(false);
  }

  expand() {
    this.props.updateSelected(false);
  }

  renderResult(result) {
    if (this.props.type === 'tag') {
      const [firstMessage] = result.Messages;
      return <AppSearchResult key={firstMessage.id} message={firstMessage} />;
    }
    if (this.props.type === 'conversation') {
      return <AppSearchResult key={result.id} message={result} />;
    }
    return null;
  }

  isMessageSelected() {
    if (this.props.messageIsSelected) {
      return 'minimised';
    }
    return null;
  }

  render() {
    // Only show if there are results
    if (!this.props.isOpen) return null;
    return (
      <div className={`AppSearchResults text-left ${this.isMessageSelected()}`}>
        <h1 className="results-header">
          Search Results
          <span
            className="pull-right search-close"
            onClick={this.close.bind(this)}
          >
            <GeckoIcon icon="far fa-times" />
          </span>
        </h1>
        <span
          className="search-close-minimised"
          onClick={this.close.bind(this)}
        >
          <GeckoIcon icon="far fa-times" />
          &nbsp; Close
        </span>
        <span className="search-expand" onClick={this.expand.bind(this)}>
          <GeckoIcon icon="far fa-arrow-left" />
          &nbsp; Expand
        </span>
        <div className="results-container">
          {this.props.results && this.props.results.length ? (
            this.props.results.map(this.renderResult.bind(this))
          ) : (
            <GeckoAlert type="warning">No results found</GeckoAlert>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    defaultHeaders: store.appState.defaultHeaders,
    results: store.searchResults.results,
    type: store.searchResults.type,
    term: store.searchResults.term,
    isOpen: store.searchResults.isOpen,
    messageIsSelected: store.searchResults.isSelected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSearch: (obj) => {
      dispatch(updateSearch(obj));
    },
    updateResults: (results) => {
      dispatch(updateSearchResults(results));
    },
    updateType: (type) => {
      dispatch(updateSearchType(type));
    },
    updateTerm: (term) => {
      dispatch(updateSearchTerm(term));
    },
    updateIsOpen: (isOpen) => {
      dispatch(updateSearchIsOpen(isOpen));
    },
    updateSelected: (isSelected) => {
      dispatch(updateSearchSelected(isSelected));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppSearchResults);
